import Http from "@/commons/Http";

const path = 'api/public/protocol';

export default {

    async getProtocolInformation(protocolId, accessCode){
        return Http.get(`${path}/${protocolId}/${accessCode}`);
    },

    async getProtocolNumber(protocolId, accessCode){
        return Http.get(`${path}/${protocolId}/${accessCode}/protocol-number`);
    },
}
